import { useEffect, useState } from "react";
import { useCrm } from "../../../tools/api";
import { Button, Col, Form, Input, Row, Table } from "antd";
import { NotFound } from "../../../sources/svg/svg";
import { convertToJalaliWithTime, formatDate, formatTime } from "../../../tools/tools";
import { useLayout } from "../../layouts/layout";
import PrintDocument from "../../simcardPurchase/print/printDocument";
import { useSelector } from "react-redux";
import Loading from "../../auxiliary/loader/loading";
import { successMessage } from "../../../tools/toastifyShowMessage";

const PrintDocumentCartablePost = () => {
  const { querySPPurchasePrintDocState, updateSPPurchaseFromPrintDocToPrintBarcodeState } = useCrm();

  const { setLayout } = useLayout();

  const [isLoading, setIsLoading] = useState(false);

  const formData = useSelector((state) => state);

  const [purchaseList, setPurchaseList] = useState([]);
  const [resultSearch, setResultSearch] = useState([]);

  useEffect(() => {
    CartableListServ();
  }, []);
  const CartableListServ = async () => {
    setIsLoading(true);
    let response = await querySPPurchasePrintDocState();
    if (response) {
      setPurchaseList(response?.Result);
      setResultSearch(response?.Result);
    }
    setIsLoading(false);
  };

  const retPrintHandler = (item) => {
    return {
      spbundle: {
        bundleType: item?.msisdnSimcardType,
      },
      spMsisdn: [{ msisdn: item?.msisdn }],
      spKit: item?.iCCID?.slice(9, 19),
      profile: {
        fname: item?.fName,
        lname: item?.lName,
        fathername: item?.fatherName,
        certno: item?.certNo,
        birthdate: item?.birthDate,
        fathername: item?.fatherName,
        txtCountry: "",
        gender: item?.gender,
        email: item?.email,
        postalcode: item?.postalCode,
        txtProvince: item?.provinceName,
        txtCity: item?.cityName,
        mainstreet: item?.mainStreet,
        buildingno: item?.buildingNo,
        floor: item?.floor,
      },
      branchcode: formData?.another?._currentUser?.branchcode,
    };
  };

  const handleSearch = (e) => {
    let search = e.target.value;
    let result = purchaseList.filter((item) => {
      return Object.keys(item).some((k) => {
        return String(item[k]).toLowerCase().includes(search.toLowerCase());
      });
    });
    setResultSearch(result);
  };

  const printHandler = () => {
    setIsLoading(true);
    if (purchaseList.length > 0) {
      Promise.all(
        purchaseList.map((item) => {
          return retPrintHandler(item);
        }),
      ).then((prints) => {
        let print = prints.map((print, index) => <PrintDocument key={index} print={print} lang="fa" />);
        setLayout(print);
        setTimeout(() => {
          setIsLoading(false);
          window.print();
        }, 1000);
      });
    }
  };

  const transmitToBarCode = async () => {
    setIsLoading(true);
    const response = await updateSPPurchaseFromPrintDocToPrintBarcodeState();
    if (!response?.HasError) {
      successMessage("انتقال با موفقیت انجام پذیرفت");
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className="g-body-format-page">
        <div className="holder-form-filter">
          <Form layout="vertical">
            <Row gutter={16}>
              <Col span={6}>
                <Form.Item className="input-normal" label="جستجو">
                  <Input placeholder="جستجو" dir="ltr" allowClear onChange={handleSearch} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="holder-table">
          <Table
            // rowSelection={rowSelection}
            className="tbl-normal"
            columns={[
              {
                title: "شماره آپتل",
                dataIndex: "msisdn",
                key: "msisdn",
                width: 150,
              },
              {
                title: "شماره کیت",
                dataIndex: "iccid",
                key: "iccid",
                width: 150,
              },
              {
                title: "کدملی",
                dataIndex: "certno",
                key: "certno",
                width: 150,
              },
              {
                title: "نام",
                dataIndex: "fname",
                key: "fname",
                width: 150,
              },
              {
                title: "نام خانوادگی",
                dataIndex: "lname",
                key: "lname",
                width: 150,
              },
              {
                title: "نام پدر",
                dataIndex: "fathername",
                key: "fathername",
                width: 150,
              },
              {
                title: "تاریخ خرید",
                dataIndex: "purchasedate",
                key: "purchasedate",
                width: 150,
                sorter: (a, b) => {
                  return new Date(a.purchasedate.props["data-date"]) - new Date(b.purchasedate.props["data-date"]);
                },
                showSorterTooltip: false,
              },

              {
                title: "چاپ تکی سند",
                dataIndex: "print",
                key: "print",
                width: 150,
              },
            ]}
            locale={{
              emptyText: (
                <>
                  <NotFound text={"رکوردی یافت نشد."} />
                </>
              ),
            }}
            pagination={{
              className: "page-pagination",
              // position: [totalRecord.length > 10 ? "bottomLeft" : "none"],
              align: "start",
            }}
            dataSource={resultSearch.map((item, key) => ({
              key: key,
              msisdn: item.msisdn,
              iccid: item.iCCID.slice(9, 19),
              certno: item.certNo,
              fname: item.fName,
              lname: item.lName,
              fathername: item.fatherName,
              purchasedate: (
                <span dir="ltr" data-date={item?.purchaseDate}>
                  {convertToJalaliWithTime(item.purchaseDate)} - {formatTime(new Date(item.purchaseDate))}{" "}
                </span>
              ),

              print: (
                <>
                  <Button
                    className="btn-normal"
                    onClick={() => {
                      const retData = retPrintHandler(item);
                      setLayout(<PrintDocument print={retData} lang="fa" />);
                      setTimeout(() => {
                        window.print();
                      }, 1000);
                    }}
                  >
                    چاپ سند
                  </Button>
                </>
              ),
            }))}
          ></Table>
        </div>
        <div className="holder-export-group-print">
          <Button onClick={printHandler} className="btn-normal btn-print" type="default" icon={<i className="icon-print"></i>}>
            چاپ گروهی سند
          </Button>
        </div>
      </div>
      <div className="g-footer-format-page">
        <div className="holder-button">
          <Button onClick={transmitToBarCode} htmlType="submit" className="btn-normal btn-aptel" type="primary" danger>
            انتقال به کارتابل بارکد
          </Button>
        </div>
      </div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default PrintDocumentCartablePost;
